module.exports = __webpack_public_path__ + "static/favicon-308e8e2826cd87cd13e465303e695659.ico";